import { IsNotEmpty, IsString, MaxLength, IsOptional, IsInt, IsUUID, IsArray, MinLength } from 'class-validator';
import { TeamAccessEditDTO } from '../team/team-access-edit.dto';

export class AccountEditDTO extends TeamAccessEditDTO {

    @IsNotEmpty()
    @IsString()
    @MaxLength(255)
    name: string;

    @IsOptional()
    @IsString()
    @MaxLength(255)
    friendlyName: string;

    @IsOptional()
    @IsString()
    description: string;

    @IsOptional()
    @IsString()
    @MaxLength(255)
    website: string;

    @IsOptional()
    @IsString()
    @MaxLength(255)
    email: string;

    @IsOptional()
    @IsString()
    @MaxLength(255)
    phone: string;

    @IsOptional()
    @IsString()
    @MaxLength(20)
    vatNo: string;

    @IsOptional()
    @IsInt()
    invoiceBy: number;

    @IsOptional()
    @IsInt()
    industry: number;

    @IsOptional()
    @IsArray()
    @IsString({
        each: true
    })
    @MinLength(36, {
        each: true
    })
    @MaxLength(36, {
        each: true
    })
    contacts: Array<string>;

    @IsOptional()
    @IsArray()
    @IsString({
        each: true
    })
    @MinLength(36, {
        each: true
    })
    @MaxLength(36, {
        each: true
    })
    pricelists: Array<string>;

    @IsOptional()
    @IsArray()
    @IsString({
        each: true
    })
    @MinLength(36, {
        each: true
    })
    @MaxLength(36, {
        each: true
    })
    products: Array<string>;

}
